import request from "@/utils/request";

export function getInboxThreadList(data, signal) {
  return request({
    url: "/inbox",
    method: "post",
    data,
    signal,
  });
}

export function getInboxThreadDetail(data) {
  return request({
    url: "/inbox/thread",
    method: "post",
    data,
  });
}

export function markInboxThreadRead(data) {
  return request({
    url: "/inbox/thread/read",
    method: "post",
    data,
  });
}

export function setInboxThreadState(data) {
  return request({
    url: "/inbox/thread/state",
    method: "post",
    data,
  });
}

export function bulkSetInboxThreadState(data) {
  return request({
    url: "/inbox/thread/state/bulk",
    method: "post",
    data,
  });
}

export function replyToInboxThread(data) {
  return request({
    url: "/inbox/thread/reply",
    method: "post",
    data,
  });
}

export function suggestInboxThreadReply(data) {
  return request({
    url: "/inbox/thread/reply/suggest",
    method: "post",
    data,
  });
}

// Reply / Reply-all recipient sets for the composer mode picker. Returns
// `{ reply: { to: [...], cc: [] }, reply_all: { to: [...], cc: [...] } }`. The
// composer uses this to repopulate the To / Cc tokens when the user toggles between
// reply modes.
export function getInboxReplyRecipients(data) {
  return request({
    url: "/inbox/thread/reply_recipients",
    method: "post",
    data,
  });
}

export function setInboxThreadTargetStatus(data) {
  return request({
    url: "/inbox/thread/target/status",
    method: "post",
    data,
  });
}

export function getInboxMetadata(data) {
  return request({
    url: "/inbox/metadata",
    method: "post",
    data,
  });
}

export function getInboxUnreadCount(data) {
  return request({
    url: "/inbox/unread_count",
    method: "post",
    data: data || {},
  });
}

export function getInboxThreadActivity(data) {
  return request({
    url: "/inbox/thread/activity",
    method: "post",
    data,
  });
}

// Downloads a Nylas-stored attachment as a Blob (responseType:'blob').
export function downloadInboxAttachment(data) {
  return request({
    url: "/inbox/attachment/download",
    method: "post",
    data,
    responseType: "blob",
  });
}

export function getInboxChannels(data) {
  return request({
    url: "/inbox/channels",
    method: "post",
    data: data || {},
  });
}

export function getInboxGlance(data) {
  return request({
    url: "/inbox/glance",
    method: "post",
    data: data || {},
  });
}

// Server-driven thread-state enum (snoozed / meeting_booked / not_interested / ...).
// Cached server-side; safe to call once per session.
export function getChannelMessageThreadStatusTypes() {
  return request({
    url: "/channels/messages/thread_status",
    method: "get",
  });
}

// Inbox-wide tunables (channel limits, poll interval, etc.). Defaults come from
// backend routes/inbox/_config.js; future System_Configs overrides flow through.
export function getInboxConfig() {
  return request({
    url: "/inbox/config",
    method: "get",
  });
}
